module.exports = __webpack_public_path__ + "img/walker-sitter-2.d6eff35c.png";